export default __webpack_public_path__ + "static/media/ncinema.1d39470b.png";